module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_2",
      "title": "Photo"
    }
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "photo"
  }, [_c('img', {
    staticClass: "photo",
    attrs: {
      "alt": "3769_IMG01.psd",
      "src": "Images/3769_IMG01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("The Birmingham Good Friday march, on April 12, 1963, led by (from left) Fred Shuttlesworth, Ralph Abernathy and Martin Luther King Jr.")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("(Used by permission of Birmingham, Alabama, Public Library Archives.)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb1d853c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/photo.vue
// module id = 57
// module chunks = 0